import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type ExploreRoute from '../explore';

export default class AuthenticatedCareerPathwaysExploreIndexRoute extends Route {
  model(): ModelFrom<ExploreRoute> {
    return this.modelFor('authenticated.reimagined.explore') as ModelFrom<ExploreRoute>;
  }
}
